import { CommodityDetail } from "features/contracts/enums/commodityDetail";

export const EnumsMap: Record<string, object>  = {
  CommodityDetail: CommodityDetail
}